import useNavigationStore from '@src/stores/navigationStore';
import styles from './Header.module.scss';
import ProgressBar from '../ProgressBar';

const steps = [
    { number: 1, label: 'Identification', subSteps: [{key: 'EmailCheck'}, {key: 'Register'}] },
    { number: 2, label: 'Informations représentant légal', subSteps: [{key: 'USPerson'}, {key: 'LegalAgentSituation'}, {key: 'FinancialJob'}, {key: 'HomeAddress'}, {key: 'FiscalAddress'}, {key: 'Birth'}, {key: 'LegalCapacity'}, {key: 'Nationality'}] },
    { number: 3, label: 'Informations sur la société', subSteps: [{key: 'CompanyMisc'}, {key: 'SirenNumber'}, {key: 'CompanyInformations'}, {key: 'Various'}, {key: 'Beneficiaries'}, {key: 'BeneficiariesInformations'}]},
    { number: 4, label: 'Profil Boursier', subSteps: [{key: 'LCBFT'}, {key: 'LatestResults'}, {key: 'Informations'}] },
    { number: 5, label: 'Votre compte', subSteps: [{key: 'AccountInformations'}, {key: 'AccountOptions'}, {key: 'PriceList'}, {key: 'FundsOrigin'}, {key: 'Iban'}] },
    { number: 6, label: 'Pièces justificatives', subSteps: [{key: 'Documents'}, {key: 'Identity'}, {key: 'ProofOfAddress'}, {key: 'BeneficiariesDocuments'}, {key: 'CompanyDocuments'}, {key: 'Overview'}, {key: 'Signature'},] },
];

export default function Header() {
    const { section } = useNavigationStore();

    return (
        <header className={styles.header}>
            {section.number !== 0 && section.number !== 7 ?
                <>
                    <ProgressBar steps={steps} currentStep={section.number} currentSubStepKey={section.block}/>
                    <div className={styles.orangeLine}/>
                </>: null}
        </header>
    );
}
